export const CONDITION_OPERATORS = [
  "=",
  "!=",
  ">",
  "<",
  ">=",
  "<=",
  "LIKE",
  "ILIKE",
  "IN",
  "ISNULL",
  "ISNOTNULL",
];

export const createEmptyConditionRow = () => ({
  mode: "object",
  expression: "",
  field: "",
  operator: "=",
  value: "",
});

const shouldIgnoreValue = (operator) => ["ISNULL", "ISNOTNULL"].includes(operator);

const parseValue = (operator, value) => {
  if (shouldIgnoreValue(operator)) return undefined;
  if (operator === "IN" && typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }
  if (value === "") return "";
  const numericValue = Number(value);
  if (!Number.isNaN(numericValue) && value !== null && value !== undefined && `${value}`.trim() !== "") {
    return numericValue;
  }
  return value;
};

export const serializeTriggerCondition = ({ logic, limit, rows }) => {
  const conditions = rows
    .map((row) => {
      if (row.mode === "string") {
        return row.expression?.trim() || null;
      }
      if (!row.field?.trim() || !row.operator?.trim()) return null;
      return {
        field: row.field.trim(),
        operator: row.operator.trim(),
        value: parseValue(row.operator, row.value),
      };
    })
    .filter(Boolean);

  return {
    logic: logic || "AND",
    limit: Number(limit) > 0 ? Number(limit) : undefined,
    conditions,
  };
};
